import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { CheckoutPaymentOrderLine } from "../../checkout.types";

@Component({
    selector: "vsf-order-summary-table",
    templateUrl: "./order-summary-table.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderSummaryTableComponent {
    @Input() lines: CheckoutPaymentOrderLine[] = [];

    isDiscounted(line: CheckoutPaymentOrderLine): boolean {
        return (
            (line.discountedLinePriceWithTax ?? line.linePriceWithTax) <
            line.linePriceWithTax
        );
    }
}
